<template>
  <div class="cert-status">
    <div :class="statusClass">
      <CheckCircle
        v-if="status === 'awarded'"
        class="cert-status__awarded-icon"
      />
      <span>{{ status }}</span>
    </div>
  </div>
</template>

<script>
import CheckCircle from '@/assets/images/certification/check-circle.svg'

export default {
  name: 'CertStatus',
  components: {
    CheckCircle: { ...CheckCircle, name: 'CheckCircle' },
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    showStatus: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    statusClass() {
      if (!this.status || !this.showStatus) {
        return ['cert-status__container', 'cert-status__hidden']
      }
      return this.status === 'awarded'
        ? ['cert-status__container', 'cert-status__container--awarded']
        : ['cert-status__container', 'cert-status__container--pending']
    },
  },
}
</script>

<style lang="scss" scoped>
.cert-status {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;

  &__container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    text-transform: capitalize;
    border-top-left-radius: 10px;
    clip-path: polygon(0 0, 100% 0%, 90% 100%, 0% 100%);
    color: #1e1e1e;
    min-width: 126.26px;
    min-height: 38px;

    &--awarded {
      background: var(--positive-light);
      text-align: center;
      padding: 7px 22px 7px 14px;
    }

    &--pending {
      background: var(--glass-light-gray);
      color: #ffffff;
      text-align: center;
      padding: 7px 22px 7px 14px;
    }
  }

  &__hidden {
    visibility: hidden;
  }

  &__awarded-icon {
    align-self: center;
    margin-right: 5px;
  }
}
</style>
